import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataPage } from '../../common/models/DataPage';
import { UserAccount } from '../../session/models/index';
import { GaSessionConfigService } from '../../session/services/session.config.service';
import { EmailSettings, SmsSettings } from '../models/index';

@Injectable()
export class AccountsDataService {

    constructor(
        private http: HttpClient,
        private sessionConfigService: GaSessionConfigService
    ) { }

    private get resourse(): string { return this.sessionConfigService.serverUrl + '/api/v1/users/'; }

    getAccounts(): Observable<DataPage<UserAccount>> {
        return this.http.get<DataPage<UserAccount>>(this.resourse);
    }

    getAccountById(id: string): Observable<UserAccount> {
        return this.http.get<UserAccount>(this.resourse + id);
    }

    getCurrentAccount(): Observable<UserAccount> {
        return this.getAccountById('current');
    }

    createAccount(account: Omit<UserAccount, 'id' | 'create_time'>): Observable<UserAccount> {
        return this.http.post<UserAccount>(this.resourse, account);
    }

    updateAccount(id: string, account: UserAccount): Observable<UserAccount> {
        return this.http.put<UserAccount>(this.resourse + id, account);
    }

    deleteAccount(id: string): Observable<UserAccount> {
        return this.http.delete<UserAccount>(this.resourse + id);
    }

    verifyEmail(login: string, code: string): Observable<void> {
        return this.http.post<void>(this.resourse + 'email/verify', { login, code });
    }

    resendEmailVerification(login: string): Observable<void> {
        return this.http.post<void>(this.resourse + 'email/resend', { login });
    }

    getEmailSettings(userId: string): Observable<EmailSettings> {
        return this.http.get<EmailSettings>(this.resourse + userId + '/email');
    }

    setEmailSettings(userId: string, data: EmailSettings): Observable<EmailSettings> {
        return this.http.post<EmailSettings>(this.resourse + userId + '/email', data);
    }

    verifySms(login: string, code: string): Observable<void> {
        return this.http.post<void>(this.resourse + 'sms/verify', { login, code });
    }

    resendSmsVerification(login: string): Observable<void> {
        return this.http.post<void>(this.resourse + 'sms/resend', { login });
    }

    getSmsSettings(userId: string): Observable<SmsSettings> {
        return this.http.get<SmsSettings>(this.resourse + userId + '/sms');
    }

    setSmsSettings(userId: string, data: SmsSettings): Observable<SmsSettings> {
        return this.http.post<SmsSettings>(this.resourse + userId + '/sms', data);
    }

}
